import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full bg-white px-5 py-12 sm:py-20" data-id="element-155" data-mp="22l5dz2tolmka">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-156" data-mp="22jc31bc1cg6h">
        <span className="mb-5 inline-block rounded-full border border-cobalt/40 bg-cobalt/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-cobalt-deep" data-id="element-157" data-mp="2ge4oeqelwqkz">
          📦 Everything Inside the System
        </span>
        <h2 className="font-serif-display text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-158" data-mp="26kxnbhqwfwqp">
          Everything You Need to Teach Chemistry More Visually and Efficiently
        </h2>
        <p className="mt-5 text-base font-medium text-cobalt-deep sm:text-lg" data-id="element-159" data-mp="2zacvlzr6jbix">
          Visual Chemistry™ The Complete Chemistry Teaching System
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-cobalt/40" data-id="element-160" data-mp="uevt8lru1ddp" />
        <p className="mt-6 text-sm leading-relaxed text-ink/70 sm:text-base" data-id="element-161" data-mp="pgluy2at9wnv">
          Visual Chemistry™ gives you an organized collection of classroom-ready resources covering
          foundational chemistry, atomic structure, chemical bonding, reactions, stoichiometry,
          organic chemistry, and real-world applications.
        </p>
      </motion.div>
    </section>;
}